import uuid from 'react-native-uuid';

export default function getKeyFromEmpIdOrUUID(employeeId) {
  if (employeeId && employeeId !== null) {
    return employeeId;
  }
  return uuid.v4(); // ⇨ '11edc52b-2918-4d71-9058-f7285e29d894'
}
